/*
  Sticky add-to-cart bar (mobile). Shows after the main add-to-cart button has scrolled out of view.
  Its button clicks the main button, and it copies the main button's label and state, so the regular
  product form does all the work.
*/
if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();
        this.pastMainButton = false;
      }

      connectedCallback() {
        this.button = this.querySelector('.sticky-atc__button');
        this.text = this.button?.querySelector('span');
        this.spinner = this.button?.querySelector('.loading__spinner');
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`);
        if (!this.button || !this.mainButton) return;

        this.onButtonClick = () => this.mainButton.click();
        this.button.addEventListener('click', this.onButtonClick);

        this.syncWithMainButton();
        this.mutationObserver = new MutationObserver(() => this.syncWithMainButton());
        this.mutationObserver.observe(this.mainButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'aria-haspopup', 'class'],
          childList: true,
          characterData: true,
          subtree: true,
        });

        this.intersectionObserver = new IntersectionObserver(([entry]) => {
          this.pastMainButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.classList.toggle('is-visible', this.pastMainButton);
        });
        this.intersectionObserver.observe(this.mainButton);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onButtonClick);
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
      }

      syncWithMainButton() {
        const main = this.mainButton;
        const mainText = main.querySelector('span');
        const loading = main.classList.contains('loading');

        if (mainText && this.text) this.text.textContent = mainText.textContent;
        this.button.disabled = main.hasAttribute('disabled');

        if (main.getAttribute('aria-disabled') === 'true') {
          this.button.setAttribute('aria-disabled', 'true');
        } else {
          this.button.removeAttribute('aria-disabled');
        }

        if (main.hasAttribute('aria-haspopup')) {
          this.button.setAttribute('aria-haspopup', main.getAttribute('aria-haspopup'));
        }

        this.button.classList.toggle('loading', loading);
        this.spinner?.classList.toggle('hidden', !loading);
      }
    }
  );
}
